module.exports = __webpack_public_path__ + "static/img/MA.c832c174.svg";